import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Overlay } from "react-bootstrap";
import "./ToolButton.css";

const ToolButton = ({ handlePrint, handleCopy, handleShare }) => {
  const [showCopyTableTooltip, setShowCopyTableTooltip] = useState(false);
  const copyTableTarget = useRef(null);
  const [showCopyLinkTooltip, setShowCopyLinkTooltip] = useState(false);
  const copyLinkTarget = useRef(null);
  ToolButton.propTypes = {
    handlePrint: PropTypes.func,
    handleCopy: PropTypes.func,
    handleShare: PropTypes.func,
  };

  function resolveAfterWait() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve("Resolved");
      }, 2000); // 2 seconds
    });
  }

  // Show Copy Table Data tooltip for only a few seconds
  useEffect(() => {
    if (showCopyTableTooltip) {
      resolveAfterWait().then(() => {
        setShowCopyTableTooltip(false);
      });
    }
  }, [showCopyTableTooltip]);

  // Show Copy Link tooltip for only a few seconds
  useEffect(() => {
    if (showCopyLinkTooltip) {
      resolveAfterWait().then(() => {
        setShowCopyLinkTooltip(false);
      });
    }
  }, [showCopyLinkTooltip]);

  const shareTableClick = () => {
    if (setShowCopyLinkTooltip) {
      setShowCopyLinkTooltip(false);
    }
    setShowCopyTableTooltip(true);
    handleCopy();
  };

  const shareLinkClick = () => {
    if (showCopyTableTooltip) {
      setShowCopyTableTooltip(false);
    }
    setShowCopyLinkTooltip(true);
    handleShare();
  };

  return (
    <div className="tool-container">
      <button
        className="btn-tool buttons-copy btn-outline left-button-shape"
        aria-controls="myTable"
        type="button"
        title="Copy to Clipboard"
        onClick={() => shareTableClick()}
        ref={copyTableTarget}
      >
        Copy
      </button>
      <button
        className="btn-tool btn-secondary btn-outline usa-tooltip"
        type="button"
        title="Share Link"
        onClick={() => shareLinkClick()}
        ref={copyLinkTarget}
      >
        Share
      </button>
      <Overlay
        placement="bottom"
        show={showCopyLinkTooltip}
        target={copyLinkTarget.current}
        aria-hidden={true}
      >
        {({
          placement: _placement,
          arrowProps: _arrowProps,
          show: _show,
          popper: _popper,
          hasDoneInitialMeasure: _hasDoneInitialMeasure,
          ...props
        }) => (
          <div
            {...props}
            style={{
              position: "absolute",
              backgroundColor: "rgb(36, 52, 19)",
              marginTop: "5px",
              padding: "2px 10px",
              color: "white",
              borderRadius: 3,
              ...props.style,
            }}
          >
            Link copied
          </div>
        )}
      </Overlay>
      <Overlay
        placement="bottom"
        show={showCopyTableTooltip}
        target={copyTableTarget.current}
        aria-hidden={true}
      >
        {({
          placement: _placement,
          arrowProps: _arrowProps,
          show: _show,
          popper: _popper,
          hasDoneInitialMeasure: _hasDoneInitialMeasure,
          ...props
        }) => (
          <div
            {...props}
            style={{
              position: "absolute",
              backgroundColor: "rgb(36, 52, 19)",
              marginTop: "5px",
              padding: "2px 10px",
              color: "white",
              borderRadius: 3,
              ...props.style,
            }}
          >
            Table data copied
          </div>
        )}
      </Overlay>
      <button
        className="btn-tool btn-secondary buttons-print btn-outline right-button-shape"
        aria-controls="myTable"
        type="button"
        title="Print"
        onClick={() => handlePrint()}
      >
        Print
      </button>
    </div>
  );
};

export default ToolButton;
